import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
  name: 'cpfc'
})
@Injectable()
export class CpfcPipe implements PipeTransform {
  private readonly startValueForRound = 10;
  transform(value: number): number {
    if (Math.abs(value) > this.startValueForRound) {
      return Math.round(value);
    }
    return Math.round(value * 10) / 10;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/cpfc.pipe.ts